import { CategoryLimit } from "../../domain/entities/CategoryLimit";
import { CategoryLimits } from "../../domain/entities/CategoryLimits";
import { CategoryLimitFormData, CategoryLimitsFormData } from "../types/CategoryLimitsTypes";

/** What the user edits in one block. Ticks are the effective ones, inactive lines never. */
export function mapCategoryLimitToFormData(block: CategoryLimit): CategoryLimitFormData {
  return {
    enabled: block.enabled,
    included: block.included,
    max: block.max,
    tickedExtraTickers: block.tickedExtraTickers,
  };
}

/** The stored state as the initial form state. */
export function mapCategoryLimitsToFormData(limits: CategoryLimits): CategoryLimitsFormData {
  return Object.fromEntries(
    limits.blocks.map(block => [block.category, mapCategoryLimitToFormData(block)])
  );
}

/**
 * The loaded section with the user's edits applied. A block missing from the form keeps its
 * stored state; a form key for a block the section lacks is ignored.
 */
export function mapCategoryLimitsFormDataToDomain(
  limits: CategoryLimits,
  formData: Partial<Record<string, Partial<CategoryLimitFormData>>> | undefined
): CategoryLimits {
  return limits.blocks.reduce((section, block) => {
    const edited = formData?.[block.category];
    return edited ? section.withBlock(applyFormData(block, edited)) : section;
  }, limits);
}

function applyFormData(block: CategoryLimit, edited: Partial<CategoryLimitFormData>) {
  return CategoryLimit.of({
    category: block.category,
    enabled: edited.enabled ?? false,
    included: edited.included,
    max: edited.max,
    extras: [...block.extras],
    tickedExtraTickers: edited.tickedExtraTickers ?? [],
  });
}
